var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vue-app" }, [
    _c("div", { staticClass: "container form-container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 col-md-4 my-3" }, [
          _c("div", { staticClass: "patient-education-content" }, [
            _c("h2", { class: _vm.post_title_h_style }, [
              _vm._v(_vm._s(_vm.post_title)),
            ]),
            _vm._v(" "),
            _c("div", {
              domProps: { innerHTML: _vm._s(_vm.post_description) },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-md-8 my-3" }, [
          _c("form", { attrs: { id: "patient-education-search-form" } }, [
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "col-12 col-md-6 mb-3 mb-md-0" }, [
                _c("h3", { staticClass: "h5" }, [_vm._v("Search by Keyword")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.keyword,
                      expression: "form.keyword",
                    },
                  ],
                  ref: "keyword",
                  staticClass: "form-control",
                  attrs: {
                    id: "keyword",
                    type: "text",
                    placeholder: "Keyword",
                  },
                  domProps: { value: _vm.form.keyword },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "keyword", $event.target.value)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 col-md-6 mb-3 mb-md-0" },
                [
                  _c("h3", { staticClass: "h5" }, [
                    _vm._v("Search by Cancer Type"),
                  ]),
                  _vm._v(" "),
                  _c("multiselect", {
                    ref: "search_cancer_type",
                    attrs: {
                      id: "search-cancer-type",
                      options: _vm.cancer_types,
                      multiple: true,
                      placeholder: "Cancer Type:",
                      "close-on-select": false,
                      "clear-on-select": true,
                      selectLabel: "Press enter or click to select",
                      deselectLabel: "Press enter or click to remove",
                      label: "text",
                      "track-by": "id",
                      maxHeight: _vm.dropdownHeight,
                    },
                    on: {
                      open: _vm.onMultiselectOpen,
                      close: _vm.onMultiselectClose,
                    },
                    model: {
                      value: _vm.form.cancer_type,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "cancer_type", $$v)
                      },
                      expression: "form.cancer_type",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-row mt-3" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary mr-1",
                  attrs: { type: "submit" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.searchResults(true)
                    },
                  },
                },
                [_vm._v("Search")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-dark",
                  attrs: { type: "submit" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.resetForm()
                    },
                  },
                },
                [_vm._v("Reset Form")]
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }